export default {
  en: {
    common: {
      save: 'Save',
      saveSuccess: 'Save Successful',
      requestSuccess: 'Request Successful',
      ok: 'OK',
      cancel: 'Cancel',
      submit: 'Submit',
      tip: 'Tip'
    },
    errors: {
      notEmpty: {
        pwd: 'Password cannot be empty.',
        queueRequestURL: 'Please scan QR code first.',
        insurance: 'Please select a insurance first.',
        qrCode: 'QR code error.'
      }
    },
    auth: {
      login: 'Login',
      username: 'Username',
      staffNo: 'StaffNo',
      password: 'Password',
      signIn: 'Sign In',
      remeber: 'Remember account',
      reScan: 'Branch code lost,Please rescan the QR code'
    },
    home: {
      queueRequest: 'Queue Request',
      scanQRCode: 'Scan QR Code',
      queueType: 'Queue type',
      company: 'Company',
      normal: 'Normal',
      selectIns: 'Select insurance',
      validation: 'Validation',
      inputPwd: 'Input your password',
      confirm: 'Confirm queue request?'
    },
    profile: {
      title: 'Profile',
      firstName: 'First Name',
      lastName: 'Last Name',
      name: 'Name',
      alias: 'Alias Name',
      gender: 'Gender',
      ic: 'NRIC',
      birthday: 'Birthday',
      postal: 'Postal',
      address: 'Address',
      maritalStatus: 'Marital Status',
      nationality: 'Nationality',
      country: 'Country',
      language: 'Language',
      race: 'Race',
      religion: 'Religion',
      changePwd: 'Change Password',
      signOut: 'Sign Out',
      confirmSignOut: 'Are you sure to sign out?'
    }
  }
}
